import { FC, memo, useState } from "react";
import { AnimatePresence } from "framer-motion";
import styled from "styled-components";

import ToggableHeading from "@/components/ToggableHeading";
import AddButton from "@/components/AddButton";
import NotesModal from "./NotesModal";
import { ProductionNoteResource } from "@/types/resources";
import NoteItem from "./NoteItem";

const NotesBox = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  margin-bottom: 60px;
`;

export const AddButtonHolder = styled.div`
  text-align: center;
  padding: 12px 24px;
  background: ${({ theme }) => theme.colors.white};
`;

interface Props {
  notes?: ProductionNoteResource[];
}

const Notes: FC<Props> = memo(({ notes }) => {
  const [isOpen, setIsOpen] = useState(true);

  const [showNotesModal, setShowNotesModal] = useState(false);

  return (
    <>
      <ToggableHeading
        heading="NOTES"
        onToggle={() => setIsOpen((prev) => !prev)}
        isOpen={isOpen}
      />
      {isOpen && (
        <NotesBox>
          {notes?.map((note, index) => (
            <NoteItem key={note.id} note={note} index={index} />
          ))}
          <AddButtonHolder>
            <AddButton onClick={() => setShowNotesModal(true)}>
              Add note
            </AddButton>
          </AddButtonHolder>
        </NotesBox>
      )}
      <AnimatePresence>
        {showNotesModal && (
          <NotesModal onClose={() => setShowNotesModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
});

export default Notes;
